import React from "react";

const CashSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="16" rx="2" fill="#E8FFEF" />
      <path
        d="M22 0C23.1046 0 24 0.895431 24 2V14C24 15.0357 23.2128 15.887 22.2041 15.9893L22 16H2L1.7959 15.9893C0.787223 15.887 0 15.0357 0 14V2C0 0.895431 0.895431 3.22128e-08 2 0H22ZM2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H22C22.5523 15 23 14.5523 23 14V2C23 1.44771 22.5523 1 22 1H2ZM12.9434 2.93555V4.01953C14.3514 4.27803 15.2094 5.22951 15.1709 6.39551L13.2734 6.40625C13.2019 5.81251 12.9767 5.41127 12.1797 5.41113C11.3272 5.41113 10.9248 5.77998 10.9248 6.20898C10.925 6.62667 11.1402 6.83517 11.9209 7.0166L13.1807 7.29785C14.6763 7.63343 15.3037 8.52455 15.3037 9.79492C15.3035 11.0101 14.4013 11.8456 12.9277 12.0547V13.001H11.3379V12.0605C9.798 11.8736 8.82413 11.1146 8.68652 9.67383L10.6338 9.65723C10.7823 10.295 11.3377 10.6522 12.1514 10.6523C12.8827 10.6523 13.3171 10.2732 13.3174 9.79492C13.3174 9.26142 12.9711 9.08538 12.2451 8.94238L10.9746 8.7002C9.74818 8.47467 8.93935 7.72605 8.92285 6.43359C8.90658 5.11933 9.94114 4.24465 11.3545 4.01367V2.93555H12.9434Z"
        fill="#317D4F"
      />
    </svg>
  );
};

export default CashSmallIcon;
